module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "copyright",
    attrs: {
      "id": "cop"
    }
  }, [_c('p', {
    staticClass: "crt"
  }, [_c('strong', [_vm._v("CIDER BEANS, WILD GREENS, AND DANDELION JELLY")]), _vm._v(" copyright © 2010 by Joan E. Aller. Food photographs copyright © 2010 by Ben Fink. All rights reserved. Printed in China. No part of this book may be used or reproduced in any manner whatsoever without written permission except in the case of reprints in the context of reviews. For information, write Andrews McMeel Publishing, LLC, an Andrews McMeel Universal company, 1130 Walnut Street, Kansas City, Missouri 64106."), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("E-ISBN: 978-1-4494-0018-7")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Library of Congress Control Number: 2009940830")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('a', {
    staticClass: "pubhlink",
    attrs: {
      "href": "http://www.andrewsmcmeel.com",
      "target": "_blank"
    }
  }, [_vm._v("www.andrewsmcmeel.com")])]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Design by Vertigo Design NYC"), _c('br'), _vm._v("Food photography by Ben Fink"), _c('br'), _vm._v("Photo on page vi courtesy of The Hawkesdene House"), _c('br'), _vm._v("Photo on page 132 courtesy of The Creekwalk Inn"), _c('br'), _vm._v("Photos on pages 3, 5, 6, 8, 9, 40, 45, 108, and 170 courtesy of Joan E. Aller"), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("ATTENTION: SCHOOLS AND BUSINESSES"), _c('br'), _vm._v("Andrews McMeel books are available at quantity discounts with bulk purchase for educational, business, or sales promotional use. For information, please write to: Special Sales Department, Andrews McMeel Publishing, LLC, 1130 Walnut Street, Kansas City, Missouri 64106.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "mailto://specialsales@amuniversal.com",
      "target": "_blank"
    }
  }, [_vm._v("specialsales@amuniversal.com")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32cde3c4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9781449400187_epub_cop_r1.vue
// module id = 72
// module chunks = 0